import { render } from "./RecentlyViewed.vue?vue&type=template&id=19a12798&scoped=true"
import script from "./RecentlyViewed.vue?vue&type=script&lang=js"
export * from "./RecentlyViewed.vue?vue&type=script&lang=js"

import "./RecentlyViewed.vue?vue&type=style&index=0&id=19a12798&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19a12798"]])

export default __exports__